'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = require('@progress/kendo-base-components-vue-wrapper');

var _RangeSliderProps = require('./RangeSliderProps');

var _RangeSliderProps2 = _interopRequireDefault(_RangeSliderProps);

var _Tooltip = require('../Common/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _RangeSliderProps2.default,
    render: function render(h) {
        return h('div', [h('input', {
            props: {
                name: this.selectionStartName
            }
        }), h('input', {
            props: {
                name: this.selectionEndName
            }
        })]);
    },

    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseInputComponent, _Tooltip2.default],
    mounted: function mounted() {
        var that = this;
        kendo.jQuery(that.$el).kendoRangeSlider(that.widgetOptions);

        that.$emit('kendowidgetready', that.kendoWidget());

        that.kendoWidget().bind('change', function () {
            that.$emit('changemodel', that.kendoWidget().value());
        });

        that.kendoWidget().bind('slide', function () {
            that.$emit('changemodel', that.kendoWidget().value());
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoRangeSlider();
        }
    },
    computed: {
        nameAttr: function nameAttr() {
            return this.$attrs.name;
        },
        selectionStartName: function selectionStartName() {
            var nameAttr = this.nameAttr;
            return nameAttr ? nameAttr + '[0]' : null;
        },
        selectionEndName: function selectionEndName() {
            var nameAttr = this.nameAttr;
            return nameAttr ? nameAttr + '[1]' : null;
        }
    }
};